import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Folder, DollarSign, Wrench, Receipt, Scale, Settings, HelpCircle, ShoppingBag, List, FileCode, Boxes, ClipboardList, Package, BarChart3 } from 'lucide-react';
import theme from '../theme';

const CreatorSidebar = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { icon: LayoutDashboard, label: 'Dashboard', path: '/creator/dashboard',                testId: 'creator-nav-dashboard' },
    { icon: BarChart3, label: 'Analytics', path: '/creator/analytics',                       testId: 'creator-nav-analytics' },
    { icon: Folder, label: 'Portfolios', path: '/creator/portfolios',                       testId: 'creator-nav-portfolios' },
    { icon: FileCode, label: 'Contracts', path: '/creator/contracts/templates',             testId: 'creator-nav-contract-templates' },
    { icon: Boxes, label: 'NFT Metadata', path: '/creator/nft/projects',                    testId: 'creator-nav-nft' },
    { icon: ShoppingBag, label: 'Marketplace', path: '/creator/utilities-marketplace',      testId: 'creator-nav-utilities-marketplace' },
    { icon: Package, label: 'Utility Vault', path: '/creator/utility-vault',                testId: 'creator-nav-utility-vault' },
    { icon: List, label: 'My Listings', path: '/creator/my-listings',                       testId: 'creator-nav-my-listings' },
    { icon: Wrench, label: 'Utilities', path: '/creator/utilities',                         testId: 'creator-nav-utilities' },
    { icon: ClipboardList, label: 'Architect Requests', path: '/creator/architect-requests', testId: 'creator-nav-architect-requests' },
    { icon: DollarSign, label: 'Payouts', path: '/creator/payouts',                         testId: 'creator-nav-payouts' },
    { icon: Receipt, label: 'Billing', path: '/creator/billing',                            testId: 'creator-nav-billing' },
    { icon: Scale, label: 'Disputes', path: '/creator/disputes',                            testId: 'creator-nav-disputes' },
    { icon: Settings, label: 'Settings', path: '/creator/settings',                         testId: 'creator-nav-settings' },
    { icon: HelpCircle, label: 'Help', path: '/help',                                       testId: 'creator-nav-help' },
  ];

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <aside style={{
      width: '240px',
      background: theme.colors.bg.card,
      borderRight: `1px solid ${theme.colors.borders}`,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      position: 'sticky',
      top: '64px',
      overflowY: 'auto'
    }}>
      <div style={{ padding: '24px 16px' }}>
        {menuItems.map((item, idx) => (
          <div
            key={idx}
            data-testid={item.testId}
            onClick={() => navigate(item.path)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              marginBottom: '4px',
              borderRadius: theme.radius.sm,
              cursor: 'pointer',
              background: isActive(item.path) ? `${theme.colors.primary}15` : 'transparent',
              color: isActive(item.path) ? theme.colors.primary : theme.colors.text.secondary,
              fontSize: '14px',
              fontWeight: isActive(item.path) ? 600 : 500,
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.background = theme.colors.bg.secondary;
              }
            }}
            onMouseOut={(e) => {
              if (!isActive(item.path)) {
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <item.icon size={18} />
            <span>{item.label}</span>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default CreatorSidebar;
